(() => {
  const navFirstItem = document.querySelector('.mega_navigation .menu_item:not(.utility__item):not(.button)') || document.querySelector('.mega_navigation .site_logo') || document.querySelector('.mega_navigation__inner');
  const navSearchWrapper = document.querySelector('.search_wrapper');
  const searchField = document.getElementById('menu-search-field');
  const searchButton = document.getElementById('search__button');
  const searchClose = document.getElementById('search__close');
  const menuInner = document.querySelector('.mega_navigation__inner');
  const navItems = menuInner && menuInner.querySelectorAll('button, [role="button"]');
  const body = document.body;
  let logoOffset = null;

  body.classList.add('mega-header');

  menuInner.addEventListener('focusin', function () {
    if (header.classList.contains('hidden-header')) {
      header.classList.remove('hidden-header');
      body.classList.remove('hidden-header');
    }
  }, true);

  if (navFirstItem.classList.contains('site_logo')) {
    logoOffset = navFirstItem.getBoundingClientRect().right + 12;
  }
  const isMobile = () => window.innerWidth < 900;
  const setMenu = (el, show = false) => {
    navItems.forEach(prev => {
      let parent = prev.closest('.menu_item');
      let checks = parent && parent.querySelectorAll('.menu__checkbox');

      parent && parent.classList.remove('open');
      if (!show && checks) {
        checks.forEach(check => check.classList.remove('checked'));

        if (parent.classList.contains('search')) searchField.value = '';
      }

      prev.getAttribute('aria-expanded') && prev.setAttribute('aria-expanded', 'false');
    });

    if (show) {
      let parent = el.closest('.menu_item');
      parent.classList.add('open');
      el.setAttribute('aria-expanded', 'true');
    }

    el.focus();
  }

  const setSearchFieldWidth = () => {
    if (isMobile()) return;
    navSearchWrapper.style.width = (searchButton.getBoundingClientRect().left - (logoOffset ? logoOffset : navFirstItem.getBoundingClientRect().left) + searchButton.offsetWidth) + 'px';
  }
  const searchFocus = () => searchField.focus();

  if (searchButton && navSearchWrapper && navFirstItem && searchClose) {
    document.addEventListener('readystatechange', e => {
      navSearchWrapper.style.visibility = 'hidden';
      if (e.target.readyState === 'complete') {
        setSearchFieldWidth();
        navSearchWrapper.style.removeProperty('visibility');
      }
    });

    if (searchField) {
      searchButton.addEventListener('click', () => {
        setSearchFieldWidth();
        setTimeout(() => searchFocus(), 100);
      });

      searchField.addEventListener('blur', () => {
        if (searchField.value.length === 0) {
          searchClose.click();
          setMenu(searchButton);
        }
      });

      searchClose.addEventListener('click', e => {
        e.preventDefault();
        searchField.value = '';
        setMenu(searchButton);
        searchButton.focus();
      });

      searchButton.addEventListener('keydown', e => (e.key === ' ' || e.keyCode === KEYCODE_SPACE) && searchFocus());
      searchClose.addEventListener('keydown', e => {
        e.preventDefault();
        (e.key === ' ' || e.keyCode === KEYCODE_SPACE) && searchClose.click()
      });
    }

    let resetTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resetTimeout);
      resetTimeout = setTimeout(setSearchFieldWidth, 50);
    });
  }

  // ============= On Scroll Header ===============
  const header = document.querySelector('[data-navigation-node]');
  const isMenuOpened = document.getElementById('main-navigation-menu');
  const isLanguageMenuOpened = document.getElementById('language-menu-switch');
  let scrollPosition = 0;
  const getBodyRectTop = () => Math.round(body.getBoundingClientRect().top);
  const setScrollPosition = () => scrollPosition = getBodyRectTop() <= 0 ? getBodyRectTop() : 0;
  const onScroll = () => {
    if (isMenuOpened && isLanguageMenuOpened) {
      if (isMobile() && (isMenuOpened.classList.contains('checked') || isLanguageMenuOpened.classList.contains('checked'))) {
        setScrollPosition();
        return;
      }
    }

    if (!header.contains(document.activeElement)) {
      if (getBodyRectTop() >= scrollPosition) {
        body.classList.remove('hidden-header');
        header.classList.remove('hidden-header');
      } else if (!body.classList.contains('overlay-visible')) {
        body.classList.add('hidden-header');
        header.classList.add('hidden-header');
      }
    }

    if (header.parentElement.classList.contains('inverted')) {
      if ((getBodyRectTop() + window.innerHeight) >= 0)
        header.parentElement.classList.remove('scrolled-header');
      else
        header.parentElement.classList.add('scrolled-header');
    }

    setScrollPosition();
  }

  if (header) {
    let scrollTimeout;
    window.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(onScroll, 25);
    });
  }
  // ============= On Scroll Header END ===============

  const menuButton = document.querySelectorAll('.language__link, .mobile__button');
  menuButton && menuButton.forEach(button => button.addEventListener('click', () => {
    if (!isMobile()) return;

    let menuOpened = document.querySelectorAll('.menu__checkbox.checked');

    menuOpened.length && menuOpened.forEach(check => check.id !== button.dataset.checkboxLabelFor && check.classList.remove('checked'));
  }));

  let resetTimeout;
  const docHeight = () => document.documentElement.style.setProperty('--doc-height', `${window.innerHeight}px`);
  const resetHeight = () => {
    clearTimeout(resetTimeout);
    resetTimeout = setTimeout(docHeight, 50);
  };

  docHeight();
  document.addEventListener('readystatechange', e => (e.target.readyState === 'complete') && docHeight());
  window.addEventListener('resize', resetHeight);
  window.addEventListener('orientationchange', resetHeight);

  if (navItems.length) {
    navItems.forEach(item => {
      if (item.getAttribute('aria-expanded')) {
        let parent = item.closest('.menu_item');

        menuFocusTrap(parent);

        'keydown click'.split(' ').forEach(type => item.addEventListener(type, e => {
          if (isMobile()) return;

          if (e.key === ' ' || e.keyCode === KEYCODE_SPACE || type === 'click' || e.key === 'ArrowDown') {
            navItems.forEach(iItem => {
              if (iItem !== item) {
                setMenu(iItem);
              }
            });

            e.preventDefault();
            setMenu(item, !parent.classList.contains('open'));
          }
        }, false));

        'keyup mouseout'.split(' ').forEach(type => parent.addEventListener(type, e => {
          if (isMobile()) return;
          if ((parent.classList.contains('search') || searchField.value.length) && type === 'mouseout') return;
          if (e.key === 'Escape' || e.keyCode === KEYCODE_ESC || e.key === 'ArrowUp' || type === 'mouseout') setMenu(item)
        }));
      }
    });

    menuInner && menuInner.focus();
  }

  // Top Level Arrow Navigation
  const levelOnItems = menuInner && menuInner.querySelectorAll('*:not([data-mobile]) [role="button"]');
  if (levelOnItems.length) {
    const activate = (target, active, next = true) => {
      let current = 0;
      active.classList.remove('tab-focus');

      levelOnItems.forEach((item, index) => {
        if (item === target) current = next ? index + 1 : index - 1;
      });

      if (current < 0) {
        current = levelOnItems.length - 1;
      } else if (current > levelOnItems.length - 1) {
        current = 0;
      }

      levelOnItems[current].focus();
      levelOnItems[current].classList.add('tab-focus');
    };

    levelOnItems.forEach(item => item.addEventListener('keyup', e => {
      if (e.key === ('ArrowRight' || 'ArrowLeft')) e.preventDefault();

      switch (e.key) {
        case 'ArrowRight':
          activate(e.target, document.activeElement);
          break;
        case 'ArrowLeft':
          activate(e.target, document.activeElement, false);
          break;
      }
    }));
  }
})();

const KEYCODE_TAB = 9;
const KEYCODE_ENTER = 13;
const KEYCODE_ESC = 27;
const KEYCODE_SPACE = 32;

function menuFocusTrap(element) {
  let focusable = element.querySelectorAll('a, button, [role="button"][aria-haspopup="true"], input[type="text"]:not([disabled])');
  let first = focusable[1];
  let last = focusable[focusable.length - 1];

  focusable && focusable.forEach(el => {
    el.addEventListener('keydown', e => (e.key === 'Enter' || e.keyCode === KEYCODE_ENTER) && e.target.click());
  });

  element.addEventListener('keydown', e => {
    let isTab = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);
    if (!isTab || focusable.length === 1) return;

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus(); /* shift + tab */
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus(); /* tab */
    }
  });

  element.addEventListener('keyup', () => (document.activeElement === focusable[0] && focusable[0].getAttribute('aria-expanded') === 'true') && focusable[1].focus());
}
